import { components } from "@api/api";
import useAxios from "@hooks/useFetch";
import { useKeyword } from "@core/CommonDataContext";
import { ID } from "@datassential/platform-ui-lib";
import { useMemo } from "react";

const ENDPOINT = '/api/item/GetHeaderData';

export type ProfileHeaderRequest = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemHeaderRequest"];
export type ProfileHeaderResponse = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemHeader"];
export type ProfileDataResponseItem = ProfileHeaderResponse & components["schemas"]["FlavorTracker.Entities.DTO.Common.CommonKeyword"];

export function useProfileData(id: ID): {
    isLoading: boolean;
    data: ProfileDataResponseItem;
} {
    const payload = useMemo(() => ({ id }), [id]);

    const response = useAxios<ProfileHeaderResponse>({
        url: ENDPOINT,
        method: 'post',
        payload,
    });

    const keyword = useKeyword(id);

    return {
        ...response,
        data: {
            ...response.data,
            ...keyword,
        } as ProfileDataResponseItem,
    };
}
